import React, { PropsWithChildren } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Text, UsagesDataTableCell } from '/src/components';
import { Equipment, EquipmentUsage } from '/src/lib/models';
import { DataTableCell, MeteredEquipmentUsageDataForm, UnmeteredEquipmentUsageDataForm } from '/src/lib/types';
import { getPeriodFromDateString } from '/src/utils';

export type UsagesDataTableRowProps = PropsWithChildren & {
  equipmentUsage: EquipmentUsage;
  tableCells: DataTableCell[];
  cellWidth?: string | number;
  rowIndex?: number;
  quarterColumnWidth?: number;
  equipment?: Equipment;
  isCanada?: boolean;
  showQuarterColumn?: boolean;
  formValues?: UnmeteredEquipmentUsageDataForm | MeteredEquipmentUsageDataForm;
  updateFormValue?: (key: string, value: string) => void;
  formErrors?: Record<string, string>;
};

export const UsagesDataTableRow: React.FC<UsagesDataTableRowProps> = observer(({ ...props }) => {
  const {
    equipmentUsage,
    tableCells,
    cellWidth,
    rowIndex,
    quarterColumnWidth,
    isCanada = false,
    showQuarterColumn = false,
    formValues,
    updateFormValue,
    formErrors,
  } = props;

  const leftoverWidth = 100 - (quarterColumnWidth ?? 0);
  const width = cellWidth ?? (showQuarterColumn && quarterColumnWidth ? `${leftoverWidth / 6}%` : `${100 / 6}%`);

  return (
    <Box key={rowIndex} row background={rowIndex && rowIndex % 2 ? 'white' : 'light-6'}>
      {showQuarterColumn && (
        <Box
          width={`${quarterColumnWidth}%`}
          align="center"
          border={{ side: 'all', size: '0.4px', color: 'light-2' }}
          pad="small"
        >
          <Text toUpperCase weight={500}>
            {getPeriodFromDateString(equipmentUsage.start_reporting_quarter, isCanada)}
          </Text>
        </Box>
      )}
      {tableCells.map((cellData, cellIndex) => (
        <UsagesDataTableCell
          index={cellIndex}
          key={cellIndex}
          width={width}
          isEditable={cellData.isEditable}
          valueKey={cellData.valueKey}
          formValues={formValues}
          updateFormValue={updateFormValue}
          formErrors={formErrors}
          unit={cellData.unit}
          inputMode={cellData.isEditable ? cellData.inputMode : undefined}
          formatNumber={cellData.formatNumber}
        />
      ))}
    </Box>
  );
});
